<template>
  <div>
    <eb-select
      v-if="!isBillTo"
      type="text"
      v-model="office.category"
      :options="categoryOptions"
      label="label"
      placeholder="Select Category *"
    ></eb-select>
    <slot name="name" :data="office.officeName">
      <c-input
        inputType="text"
        inputId="userName"
        lableText="Office Name *"
        v-model="office.officeName"
        class="mt-3"
      />
    </slot>
    <b-row class="mt-2" v-for="(p, idx) in office.phone" :key="p + `${idx}`">
      <b-col v-if="!setValues" md="9" class="pr-0">
        <ValidationProvider
          rules="required|number"
          v-slot="{ errors }"
          name="phone number"
        >
          <c-tel-input
            inputType="number"
            v-model="p.number"
            @validate="(e) => isValidate(e, p)"
            class="m-0"
          />
          <span class="validate-error">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
      <b-col v-if="!setValues" md="3" class="pl-0">
        <b-button
          btn-special="primary"
          size="lg"
          @click="onClickPhoneButton(p, idx)"
        >
          <i class="fa fa-plus-circle mr-1"></i>
          {{ p.text }}
        </b-button>
      </b-col>
    </b-row>
    <b-row v-for="(e, idx) in office.email" :key="idx">
      <b-col md="9" class="pr-0">
        <ValidationProvider
          rules="required|email"
          v-slot="{ errors }"
          name="Email"
          v-if="!setValues"
        >
          <c-input
            inputType="Email"
            inputId="email"
            lableText="Email"
            v-model="e.mailId"
          />

          <span class="validate-error">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
      <b-col v-if="!setValues" md="3" class="pl-0">
        <b-button
          btn-special="primary"
          size="lg"
          @click="onClickEamilButton(e, idx)"
        >
          <i class="fa fa-plus-circle mr-1"></i>
          {{ e.text }}
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <GmapAutocomplete
          @place_changed="placechange1"
          class="mt-1 location-search"
          placeholder="Enter office location *"
          :options="{
            fields: ['geometry', 'formatted_address', 'address_components'],
          }"
        ></GmapAutocomplete>
      </b-col>
    </b-row>
    <div v-if="!setValues" class="streetmargintop">
      <b-row>
        <b-col md="12">
          <c-input
            type="text"
            inputId="state"
            readonly
            v-model="office.address.country"
            lableText="Country"
          />
        </b-col>
      </b-row>
      <b-row class="statemargintop">
        <b-col md="6">
          <c-input
            type="text"
            inputId="state"
            readonly
            v-model="office.address.state"
            lableText="State"
          />
        </b-col>

        <b-col md="6">
          <c-input
            type="text"
            inputId="city"
            readonly
            v-model="office.address.city"
            lableText="City"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="zipcode"
          >
            <c-input
              inputType="number"
              inputId="zipcode"
              v-model="office.address.zip"
              lableText="Zipcode"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
    </div>
    <br />
    <br />
    <slot name="footer-button" :data="office">
      <b-button
        class="btn btn-block mt-3"
        btn-color="primary"
        @click="(e) => $emit('onClickOffice', office)"
        >Next</b-button
      >
    </slot>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import cInput from "@/components/Common/CustomInput";
import cTelInput from "@/components/Common/MobileNumberInput";
import ebSelect from "@/components/FormElements/Select";
import locationMixins from "@/mixins/addressLocation";

export default {
  name: "OfficeStepper",
  mixins: [locationMixins],
  data() {
    return {
      countries: [],
      states: [],
      cities: [],
      tenant: null,
      office: {
        category: null,
        officeName: "",
        email: [
          {
            mailId: "",
            type: "5cb700733aa1ea2920089566",
            isRemovable: false,
            text: "Add New",
          },
        ],

        phone: [
          {
            country: {
              dialCode: null,
              iso2: null,
              name: null,
            },
            number: null,
            type: "5cb700733aa1ea2920089566",
            isRemovable: false,
            text: "Add New",
            isValid: false,
          },
        ],
        address: {
          country: "",
          area: "",
          state: "",
          city: "",
          street1: "",
          street2: "",
          zip: "",
          houseNumber: "",
          location: {
            coordinates: [0, 0],
          },
        },
      },
    };
  },
  props: {
    tenants: Array,
    officeData: Object,
    isBillTo: {
      type: Boolean,
      default: false,
    },
    setValues: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    cInput,
    cTelInput,
    ebSelect,
  },
  computed: {
    categoryOptions() {
      let userdata = this.$currentUserData;
      if (this.$currentUserData.category === "ZONAL_OPERATION_HEAD") {
        return [
          {
            label: "State Operating Unit",
            value: "DISTRIBUTOR",
          },
        ];
      }
      if (this.$userRole === "Tenant") {
        return [
          {
            label: "Seller",
            value: "SELLER",
          },
          {
            label: "State Operating Unit",
            value: "DISTRIBUTOR",
          },
          {
            label: "Supplier",
            value: "SUPPLIER",
          },
        ];
      } else if (
        this.$userRole === "Partner" &&
        userdata.category === "DISTRIBUTOR"
      ) {
        {
          return [
            {
              label: "Seller",
              value: "SELLER",
            },
            {
              label: "Sector Franchisee",
              value: "DEALER",
            },
          ];
        }
      } else if (
        this.$userRole === "Partner" &&
        userdata.category === "DEALER"
      ) {
        {
          return [
            {
              label: "Seller",
              value: "SELLER",
            },
            {
              label: "TSK",
              value: "SUB_DEALER",
            },
          ];
        }
      } else if (
        this.$userRole === "Partner" &&
        userdata.category === "SUB_DEALER"
      ) {
        {
          return [
            {
              label: "Seller",
              value: "SELLER",
            },
          ];
        }
      }
    },
  },
  methods: {
    placechange1(e) {
      this.placechange(e);
      this.$emit("place_changed", e);
      let mapdata = this.$store.getters["item/GetCurrentCatalogLocation"];
      if (mapdata) {
        this.office.address.country = mapdata.data.Country;
        this.office.address.city = mapdata.data.City;
        this.office.address.state = mapdata.data.State;
        this.office.address.area = mapdata.data.Area ? mapdata.data.Area : "";
        this.office.address.zip = mapdata.data.zip ? mapdata.data.zip : "";
        this.office.address.location = {
          coordinates: [mapdata.Lng, mapdata.Lat],
        };
      }
    },
    useOfficeData() {
      console.log(this.officeData);
      console.log(this.setValues);
      if (!this.setValues) return;
      this.office = this.officeData;
    },
    isValidate(e, p) {
      p.country = { ...e.country };
      p.isValid = e.isValid;
    },
    getCountry(payload) {
      this.setState(payload.id);
      this.office.address.country = payload.name;
    },
    async onClickEamilButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.office.email.push({
          mailId: "",
          type: "5cb701203aa1ea2920089568",
          isRemovable: true,
          text: "Remove",
        });
      else this.office.email.splice(idx, 1);
    },
    async onClickPhoneButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.office.phone.push({
          country: {
            dialCode: null,
            iso2: null,
            name: null,
          },
          number: null,
          type: "5cb701203aa1ea2920089568",
          isRemovable: true,
          text: "Remove",
        });
      else this.office.phone.splice(idx, 1);
    },
  },
};
</script>
<style scoped>
.location-search {
  border-radius: 0rem;
  color: rgb(0, 0, 0);
  box-shadow: none !important;
  font-family: 'Lato';
  height: 39px !important;
  border: 1px solid #dee2e6;
  padding-left: 10px;
  width: 100%;
  font-size: small;
}
[btn-color="primary"] {
  height: 41px;
  background-color: #727cf5;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: 'Lato';
  border-radius: 0px;
  height: 39px;
  width: 132px;
  background-color: #727cf5;
  color: white;
}
.statemargintop {
  margin-top: -15px !important;
}
.streetmargintop {
  margin-top: -8px !important;
}
</style>
<style>
.vue-tel-input {
  border-radius: 0px !important;
  height: 39px !important;
  border: 1px solid #dee2e6 !important;
}
</style>
